import React from 'react'
import PropTypes from 'prop-types'
import Spinner from 'react-bootstrap/Spinner'

// Placeholder rendered inside a dashboard/report card while its data is in flight.
// `minHeight` reserves roughly the space the real chart/table will occupy so the
// card doesn't collapse and then jump when the data lands.
function CardLoading({ minHeight = 300, label = 'Loading…', className = '' }) {
  return (
    <div
      className={`d-flex flex-column justify-content-center align-items-center text-muted ${className}`.trim()}
      style={{ minHeight }}
      role="status"
      aria-live="polite"
      data-testid="card-loading"
    >
      <Spinner animation="grow" variant="warning" />
      {label ? (
        <div className="small mt-2">{label}</div>
      ) : (
        <span className="visually-hidden">Loading</span>
      )}
    </div>
  )
}

CardLoading.propTypes = {
  minHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  label: PropTypes.string,
  className: PropTypes.string
}

export default CardLoading
